module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAdUlEQVR42mNgGAogYQEq/3/niv/omBR5igHdHECMz7FZRLMQoJsDyPE5MQ6jqc+p4gBa+JyiEKCbA2jpc2wOQLePpj4nKQpoYTFJIUFvB9DVYrwOGXXAoMkF9HYAzvJgxITAqANGHTDqgFEHjDpg8PeC6WE+AIl+aknmnoKHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_uni_sin.png
// module id = 5Ocx
// module chunks = 0